module.exports = __webpack_public_path__ + "static/img/20231208_06.88cadcd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2023/20231208_06.png
// module id = aGrP
// module chunks = 0